export const ClinicalFormKey_WellsScore = 'wells-score';
export const ClinicalFormKey_HeartScore = 'heart-score';
export const ClinicalFormKey_ADDScore = 'add-score';
export const ClinicalFormKey_PERCScore = 'perc-score';
export const ClinicalFormKey_qSOFAScore = 'qsofa-score';
export const ClinicalFormKey_GenevaPEScore = 'geneva-pe-score';
export const ClinicalFormKey_GenevaVTEScore = 'geneva-vte-score';
export const ClinicalFormKey_CURBScore = 'curb-score';
export const ClinicalFormKey_PortScore = 'psi-port-score';
export const ClinicalFormKey_Cha2ds2VascScore = 'cha2ds2-vasc-score';
//################################### Scores ###################################
export const ClinicalForm_WellsScore = {
    title: 'Wells Score',
    key: ClinicalFormKey_WellsScore,
    contextVariableId: 'WELLS',
    sections: [],
    _variableIds: [],
    _valueIds: []
};
export const ClinicalForm_HeartScore = {
    title: 'Heart Score',
    key: ClinicalFormKey_HeartScore,
    contextVariableId: 'HEART',
    sections: [],
    _variableIds: [],
    _valueIds: []
};
export const ClinicalForm_AddScore = {
    title: 'ADD Score',
    key: ClinicalFormKey_ADDScore,
    contextVariableId: 'ADD',
    sections: [],
    _variableIds: [],
    _valueIds: []
};
export const ClinicalForm_PERCScore = {
    title: 'PERC Score',
    key: ClinicalFormKey_PERCScore,
    contextVariableId: 'PERC',
    sections: [],
    _variableIds: [],
    _valueIds: []
};
export const ClinicalForm_qSOFAScore = {
    title: 'qSOFA Score',
    key: ClinicalFormKey_qSOFAScore,
    contextVariableId: 'qSOFA',
    sections: [],
    _variableIds: [],
    _valueIds: []
};
export const ClinicalForm_GenevaPEScore = {
    title: 'Geneva PE Score',
    key: ClinicalFormKey_GenevaPEScore,
    contextVariableId: 'Geneva PE',
    sections: [],
    _variableIds: [],
    _valueIds: []
};
export const ClinicalForm_GenevaVTEScore = {
    title: 'Geneva VTA Score',
    key: ClinicalFormKey_GenevaVTEScore,
    contextVariableId: 'Geneva VTE',
    sections: [],
    _variableIds: [],
    _valueIds: []
};
export const ClinicalForm_CURBScore = {
    title: 'CURB Score',
    key: ClinicalFormKey_CURBScore,
    contextVariableId: 'CURB',
    sections: [],
    _variableIds: [],
    _valueIds: []
};
export const ClinicalForm_PortScore = {
    title: 'PORT Score',
    key: ClinicalFormKey_PortScore,
    contextVariableId: 'PORT',
    sections: [],
    _variableIds: [],
    _valueIds: []
};
export const ClinicalFormKey_cha2ds2VascScore = {
    title: 'CHA2DS2-Vasc Score',
    key: ClinicalFormKey_Cha2ds2VascScore,
    contextVariableId: 'CHA2DS2-Vasc',
    sections: [],
    _variableIds: [],
    _valueIds: []
};
//# sourceMappingURL=consts.js.map